import { api } from './client'

/** Agency (tenant) metadata for the platform console — no tenant CRM data. */
export interface AgencyAdmin {
  id: string
  name: string
  slug: string
  status: string // trial | active | suspended
  plan: string
  planKey: string | null // assigned subscription tier (billing), null = none yet
  industry: string
  logoUrl: string | null
  userCount: number
  createdAt: string
}

export interface CreateAgencyInput {
  agencyName: string
  slug: string
  adminFullName: string
  adminEmail: string
  adminPassword: string
}

export async function listAgencies(): Promise<AgencyAdmin[]> {
  const { data } = await api.get<AgencyAdmin[]>('/api/platform/agencies')
  return data
}

export async function createAgency(input: CreateAgencyInput): Promise<AgencyAdmin> {
  const { data } = await api.post<AgencyAdmin>('/api/platform/agencies', input)
  return data
}

export async function suspendAgency(id: string): Promise<AgencyAdmin> {
  const { data } = await api.post<AgencyAdmin>(`/api/platform/agencies/${id}/suspend`, {})
  return data
}

export async function activateAgency(id: string): Promise<AgencyAdmin> {
  const { data } = await api.post<AgencyAdmin>(`/api/platform/agencies/${id}/activate`, {})
  return data
}

export async function deleteAgency(id: string): Promise<void> {
  await api.delete(`/api/platform/agencies/${id}`)
}

/** A subscription tier in the catalog. Nulls mean unlimited seats/emails or a custom price. */
export interface Plan {
  key: string
  name: string
  seatLimit: number | null
  includedEmailMonthly: number | null
  includedSmsMonthly: number
  monthlyPriceCents: number | null
  currency: string
  position: number
  active: boolean
  /** Whether this plan is wired to a Stripe price and can be checked out by an agency admin. */
  purchasable?: boolean
}

export async function listPlans(): Promise<Plan[]> {
  const { data } = await api.get<Plan[]>('/api/platform/plans')
  return data
}

export async function assignPlan(id: string, planKey: string): Promise<void> {
  await api.put(`/api/platform/agencies/${id}/plan`, { planKey })
}

export async function unassignPlan(id: string): Promise<void> {
  await api.delete(`/api/platform/agencies/${id}/plan`)
}
